(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3691],{

/***/ 62076:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(71600);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(68671));

var _jsxRuntime = __webpack_require__(52322);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08c-.18-.17-.29-.42-.29-.7 0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28-.79-.74-1.69-1.36-2.67-1.85-.33-.16-.56-.5-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z"
}), 'CallEnd');

exports.Z = _default;

/***/ }),

/***/ 61180:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dispatching",
      function () {
        return __webpack_require__(52279);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ dispatching; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/data-access/src/generated/index.tsx + 7 modules
var generated = __webpack_require__(54731);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Table/index.tsx + 3 modules
var Table = __webpack_require__(78623);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Typography/styles.tsx + 19 modules
var styles = __webpack_require__(71951);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/DashboardLayout/index.tsx + 5 modules
var DashboardLayout = __webpack_require__(27987);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/PageCard/index.tsx + 1 modules
var PageCard = __webpack_require__(87586);
// EXTERNAL MODULE: ../../node_modules/antd/es/tabs/index.js + 17 modules
var tabs = __webpack_require__(57911);
// EXTERNAL MODULE: ../../node_modules/antd/es/row/index.js
var row = __webpack_require__(3306);
// EXTERNAL MODULE: ../../node_modules/antd/es/space/index.js + 1 modules
var space = __webpack_require__(94187);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Tooltip/index.tsx + 1 modules
var Tooltip = __webpack_require__(77435);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(18667);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/compareAsc/index.js
var compareAsc = __webpack_require__(2463);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/differenceInMonths/index.js + 4 modules
var differenceInMonths = __webpack_require__(69233);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/differenceInSeconds/index.js
var differenceInSeconds = __webpack_require__(27121);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/defaultLocale/index.js + 10 modules
var defaultLocale = __webpack_require__(15344);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(66700);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/assign/index.js
function assign_assign(target, object) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }
  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      ;
      target[property] = object[property];
    }
  }
  return target;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/cloneObject/index.js

function cloneObject(object) {
  return assign_assign({}, object);
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(1645);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(19785);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/formatDistance/index.js










var MINUTES_IN_DAY = 1440;
var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var MINUTES_IN_MONTH = 43200;
var MINUTES_IN_TWO_MONTHS = 86400;

/**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @param {Date|Number} date - the date
 * @param {Date|Number} baseDate - the date to compare with
 * @param {Object} [options] - an object with options.
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `baseDate` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */

function formatDistance(dirtyDate, dirtyBaseDate, options) {
  var _ref, _options$locale;
  (0,requiredArgs/* default */.Z)(2, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale/* default */.Z;
  if (!locale.formatDistance) {
    throw new RangeError('locale must contain formatDistance property');
  }
  var comparison = (0,compareAsc/* default */.Z)(dirtyDate, dirtyBaseDate);
  if (isNaN(comparison)) {
    throw new RangeError('Invalid time value');
  }
  var localizeOptions = assign_assign(cloneObject(options), {
    addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
    comparison: comparison
  });
  var dateLeft;
  var dateRight;
  if (comparison > 0) {
    dateLeft = (0,toDate/* default */.Z)(dirtyBaseDate);
    dateRight = (0,toDate/* default */.Z)(dirtyDate);
  } else {
    dateLeft = (0,toDate/* default */.Z)(dirtyDate);
    dateRight = (0,toDate/* default */.Z)(dirtyBaseDate);
  }
  var seconds = (0,differenceInSeconds/* default */.Z)(dateRight, dateLeft);
  var offsetInSeconds = ((0,getTimezoneOffsetInMilliseconds/* default */.Z)(dateRight) - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(dateLeft)) / 1000;
  var minutes = Math.round((seconds - offsetInSeconds) / 60);
  var months;

  // 0 up to 2 mins
  if (minutes < 2) {
    if (options !== null && options !== void 0 && options.includeSeconds) {
      if (seconds < 5) {
        return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
      } else if (seconds < 10) {
        return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
      } else if (seconds < 20) {
        return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
      } else if (seconds < 40) {
        return locale.formatDistance('halfAMinute', 0, localizeOptions);
      } else if (seconds < 60) {
        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
      } else {
        return locale.formatDistance('xMinutes', 1, localizeOptions);
      }
    } else {
      if (minutes === 0) {
        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
      } else {
        return locale.formatDistance('xMinutes', minutes, localizeOptions);
      }
    }

    // 2 mins up to 0.75 hrs
  } else if (minutes < 45) {
    return locale.formatDistance('xMinutes', minutes, localizeOptions);

    // 0.75 hrs up to 1.5 hrs
  } else if (minutes < 90) {
    return locale.formatDistance('aboutXHours', 1, localizeOptions);

    // 1.5 hrs up to 24 hrs
  } else if (minutes < MINUTES_IN_DAY) {
    var hours = Math.round(minutes / 60);
    return locale.formatDistance('aboutXHours', hours, localizeOptions);

    // 1 day up to 1.75 days
  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return locale.formatDistance('xDays', 1, localizeOptions);

    // 1.75 days up to 30 days
  } else if (minutes < MINUTES_IN_MONTH) {
    var days = Math.round(minutes / MINUTES_IN_DAY);
    return locale.formatDistance('xDays', days, localizeOptions);

    // 1 month up to 2 months
  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
    months = Math.round(minutes / MINUTES_IN_MONTH);
    return locale.formatDistance('aboutXMonths', months, localizeOptions);
  }
  months = (0,differenceInMonths/* default */.Z)(dateRight, dateLeft);

  // 2 months up to 12 months
  if (months < 12) {
    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
    return locale.formatDistance('xMonths', nearestMonth, localizeOptions);

    // 1 year up to max Date
  } else {
    var monthsSinceStartOfYear = months % 12;
    var years = Math.floor(months / 12);

    // N years up to 1 years 3 months
    if (monthsSinceStartOfYear < 3) {
      return locale.formatDistance('aboutXYears', years, localizeOptions);

      // N years 3 months up to N years 9 months
    } else if (monthsSinceStartOfYear < 9) {
      return locale.formatDistance('overXYears', years, localizeOptions);

      // N years 9 months up to N year 12 months
    } else {
      return locale.formatDistance('almostXYears', years + 1, localizeOptions);
    }
  }
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/intervalToDuration/index.js + 10 modules
var intervalToDuration = __webpack_require__(82538);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/date.ts
var date = __webpack_require__(35838);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Warning/useWarning.ts
var useWarning = __webpack_require__(52592);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/message/index.ts
var message = __webpack_require__(7476);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Button/index.tsx + 1 modules
var Button = __webpack_require__(81824);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/CallEnd.js
var CallEnd = __webpack_require__(62076);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Modal/index.tsx + 10 modules
var Modal = __webpack_require__(51729);
;// CONCATENATED MODULE: ../../libs/pages/src/admin-application/Dispatching/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: 10px;\n  border-radius: 12px;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 4px;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  background-color: transparent;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16.8px;\n  display: flex;\n  min-width: 50px;\n  white-space: nowrap;\n  padding: 0;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: 6.11px;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}





const styles_Modal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* SimpleModal */.Y)(_templateObject());
const PersonInformation = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z)(_templateObject1(), (param)=>{
    let { $vetterOrClientNotExist , theme  } = param;
    return !$vetterOrClientNotExist ? theme.colors.green20 : theme.colors.red20;
});
const HeaderWrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2());
const CallEndButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z)(_templateObject3());
const CallIcon = (0,styled_components_browser_esm/* default */.ZP)(CallEnd/* default */.Z)(_templateObject4());

;// CONCATENATED MODULE: ../../libs/pages/src/admin-application/Dispatching/EndSession.tsx





const EndSession = (param)=>{
    let { sessionId  } = param;
    const warning = (0,useWarning/* useWarning */.r)();
    const [endSession, { loading: submitting  }] = (0,generated/* useAdminTerminateSessionMutation */.yEE)({
        variables: {
            sessionId
        },
        onCompleted: (param)=>{
            let { adminTerminateSession  } = param;
            if (adminTerminateSession.__typename === "NotFoundError") {
                return message/* message.error */.y.error("Session not found");
            }
        }
    });
    const handleClick = ()=>{
        return warning.openWarning({
            text: "Are you sure you want to end the session?",
            okText: "Yes",
            cancelText: "No",
            onOk: ()=>endSession()
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CallEndButton, {
            type: "ghost",
            loading: submitting,
            onClick: handleClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CallIcon, {}),
                "End Session"
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../libs/pages/src/admin-application/Dispatching/columns.tsx






const columns = (sessionStatus)=>{
    return [
        {
            title: "Session ID",
            dataIndex: "id"
        },
        {
            title: "Location",
            dataIndex: "location"
        },
        {
            title: "Company",
            key: "companyName",
            render: (_, param)=>{
                let { jobOffer  } = param;
                return jobOffer === null || jobOffer === void 0 ? void 0 : jobOffer.client.companyName;
            }
        },
        {
            title: "Created at",
            key: "createdAt",
            render: (_, param)=>{
                let { createdAt  } = param;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                        title: (0,date/* formatInUTC */.YX)(createdAt),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Text */.xv, {
                            children: formatDistance(new Date(createdAt), new Date()).replace("about", "~") + " ago"
                        })
                    })
                });
            }
        },
        {
            title: "Duration",
            key: "activeDuration",
            render: (_, param)=>{
                let { activeDuration  } = param;
                if (!activeDuration) return "no duration";
                const formattedDuration = (0,intervalToDuration/* default */.Z)({
                    start: 0,
                    end: activeDuration
                });
                const { hours , minutes , seconds  } = formattedDuration;
                return "".concat(hours, "h ").concat(minutes, "m ").concat(seconds, "s");
            }
        },
        {
            title: "Status",
            dataIndex: "status",
            render: (_, param)=>{
                let { canceled , status  } = param;
                return canceled ? "CANCELED - ".concat(status) : status;
            }
        },
        ...sessionStatus === generated/* SessionStatusFilterEnum.IN_PROGRESS */.Nn0.IN_PROGRESS ? [
            {
                title: "Action",
                dataIndex: "id",
                render: (id)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EndSession, {
                        sessionId: id
                    }, id);
                }
            }
        ] : []
    ];
};

// EXTERNAL MODULE: ../../libs/frontend-utils/src/router/index.tsx
var router = __webpack_require__(86450);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/hooks/useThrottleSubscription.ts
var useThrottleSubscription = __webpack_require__(72605);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/hooks/useLoadingPromiseHandler.ts
var useLoadingPromiseHandler = __webpack_require__(48892);
// EXTERNAL MODULE: ../../node_modules/@firebase/database/dist/index.esm2017.js
var index_esm2017 = __webpack_require__(85958);
;// CONCATENATED MODULE: ../../node_modules/firebase/database/dist/index.esm.js

//# sourceMappingURL=index.esm.js.map

// EXTERNAL MODULE: ../../libs/frontend-utils/src/firebase/app.ts
var app = __webpack_require__(14778);
;// CONCATENATED MODULE: ../../libs/frontend-utils/src/firebase/database.ts
/* provided dependency */ var process = __webpack_require__(34406);



const database = (0,index_esm2017/* getDatabase */.N8)(app/* app */.l);
if ( true && process.env.NEXT_PUBLIC_FIREBASE_AUTH_EMULATOR_HOST && process.env.NEXT_PUBLIC_FIREBASE_DATABASE_EMULATOR_HOST) {
    console.log("You are now logged to firebase database emulator");
    const [host, port] = process.env.NEXT_PUBLIC_FIREBASE_DATABASE_EMULATOR_HOST.split(":");
    (0,index_esm2017/* connectDatabaseEmulator */.dH)(database, host, parseInt(port));
}
const useWatchRef = (path, onChange)=>{
    useEffect(()=>{
        if (!path) {
            onChange === null || onChange === void 0 ? void 0 : onChange(undefined);
            return;
        }
        return onValue(ref(database, path), async (snapshot)=>{
            await (onChange === null || onChange === void 0 ? void 0 : onChange(snapshot.val()));
        });
    }, [
        path,
        onChange
    ]);
};
const useWatchRefState = (path)=>{
    const [loading, setLoading] = useState(true);
    const [value, setValue] = useState();
    useWatchRef(path, useCallback((value)=>{
        setValue(value);
        setLoading(false);
    }, [
        setValue,
        setLoading
    ]));
    return [
        value,
        loading
    ];
};
const getValue = async (path)=>{
    const snapshot = await get(ref(database, path));
    return snapshot.val();
};
const remove = async (path)=>{
    return (0,index_esm2017/* remove */.Od)((0,index_esm2017/* ref */.iH)(database, path));
};

// EXTERNAL MODULE: ../../node_modules/antd/es/tooltip/index.js + 3 modules
var tooltip = __webpack_require__(55003);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Form/index.tsx
var Form = __webpack_require__(72131);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Space/styles.ts
var Space_styles = __webpack_require__(81983);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/FormItem/index.tsx + 3 modules
var FormItem = __webpack_require__(74606);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Input/index.tsx + 1 modules
var Input = __webpack_require__(68880);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/PhoneInput/index.tsx + 1 modules
var PhoneInput = __webpack_require__(65850);
;// CONCATENATED MODULE: ../../libs/pages/src/admin-application/Dispatching/EnterApplicationManuallyModal.tsx






const EnterApplicationManuallyModal = (param)=>{
    let { visible , onCancel  } = param;
    const [form] = Form/* Form.useForm */.l.useForm();
    const [adminProcessApplication, processApplicationMutation] = (0,generated/* useAdminProcessApplicationMutation */.I$j)({
        onCompleted: (param)=>{
            let { adminProcessApplication  } = param;
            switch(adminProcessApplication === null || adminProcessApplication === void 0 ? void 0 : adminProcessApplication.__typename){
                case "SuccessResult":
                    message/* message.success */.y.success(adminProcessApplication.message);
                    form.resetFields();
                    onCancel === null || onCancel === void 0 ? void 0 : onCancel();
                    break;
                case "ValidationError":
                    message/* message.error */.y.error(adminProcessApplication.messages[0]);
                    break;
                case "NotFoundError":
                    message/* message.error */.y.error(adminProcessApplication.message);
                    break;
                default:
                    message/* message.error */.y.error("Application creation failed due to unexpected error");
                    break;
            }
        }
    });
    const handleSubmit = async (values)=>{
        await adminProcessApplication({
            variables: {
                application: values
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Modal, {
        width: "624px",
        destroyOnClose: true,
        onCancel: ()=>{
            form.resetFields();
            onCancel === null || onCancel === void 0 ? void 0 : onCancel();
        },
        footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
            type: "primary",
            htmlType: "submit",
            onClick: ()=>form.submit(),
            loading: processApplicationMutation.loading,
            children: "Add Application"
        }),
        visible: visible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Form */.l, {
            form: form,
            onFinish: handleSubmit,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Space_styles/* Space */.T, {
                $fullWidth: true,
                direction: "vertical",
                size: 22,
                align: "start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* FormItem */.x, {
                        label: "Applicant's First Name",
                        name: "firstName",
                        rules: [
                            {
                                required: true,
                                message: "Applicant's First Name is required"
                            }
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* FormItem */.x, {
                        label: "Applicant's Last Name",
                        name: "lastName",
                        rules: [
                            {
                                required: true,
                                message: "Applicant's Last Name is required"
                            }
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* FormItem */.x, {
                        label: "Phone Number",
                        name: "phone",
                        rules: [
                            {
                                required: true,
                                message: "Phone Number is required"
                            }
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneInput/* PhoneInput */.s, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* FormItem */.x, {
                        label: "Job Offer Id",
                        name: "jobOfferId",
                        rules: [
                            {
                                required: true,
                                message: "Job offer ID is required"
                            }
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {})
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ../../libs/pages/src/admin-application/Dispatching/Header.tsx







const Header = ()=>{
    const [handleReattachListeners, { loading: reattachListenersLoading  }] = useLoadingPromiseHandler/* useLoadingPromiseHandler */.q(()=>remove("/listener"));
    const [showAddApplicationModal, setShowAddApplicationModal] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const hash = window.location.hash;
        if (hash.includes("#modal")) {
            setShowAddApplicationModal(true);
            const newUrl = window.location.href.replace("#modal", "");
            window.history.replaceState(null, "", newUrl);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderWrap, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                trigger: [
                    "hover"
                ],
                title: "Use this button if you see a session being stuck",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    type: "primary",
                    loading: reattachListenersLoading,
                    onClick: handleReattachListeners,
                    children: "Reattach Listeners"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                trigger: [
                    "hover"
                ],
                title: "Use this button to enter applications that haven't been scraped.",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    type: "primary",
                    loading: false,
                    onClick: ()=>setShowAddApplicationModal(true),
                    children: "Enter Application Manually"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EnterApplicationManuallyModal, {
                onCancel: ()=>setShowAddApplicationModal(false),
                visible: showAddApplicationModal
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../libs/pages/src/admin-application/Dispatching/index.tsx









const Dispatching = ()=>{
    const [status, setStatus] = (0,react.useState)(generated/* SessionStatusFilterEnum.IN_PROGRESS */.Nn0.IN_PROGRESS);
    const { data , loading , refetch  } = (0,generated/* useLastSessionsQuery */._7M)({
        variables: {
            filter: status
        }
    });
    const { getPath , pages  } = (0,router/* useCustomRouter */.cD)();
    useThrottleSubscription/* useThrottleSubscription */.i(refetch, 5000, generated/* useSessionChangedSubscription */.myk);
    const { TabPane  } = tabs/* default */.Z;
    const callback = (key)=>{
        setStatus(key);
    };
    const table = (sessionStatus)=>{
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Table/* Table */.i, {
            expandable: {
                expandedRowRender: (record)=>{
                    var ref;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                justify: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonInformation, {
                                    $vetterOrClientNotExist: !record.applicant,
                                    children: record.applicant ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                                justify: "center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Text */.xv, {
                                                    children: "Applicant: ".concat(record.applicant.firstName, " ").concat(record.applicant.lastName)
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                                justify: "center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Text */.xv, {
                                                    children: [
                                                        "Phone: ",
                                                        record.applicant.phone
                                                    ]
                                                })
                                            })
                                        ]
                                    }) : "No Applicant Information"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                justify: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonInformation, {
                                    $vetterOrClientNotExist: !record.vetter,
                                    children: record.vetter ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                                justify: "center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Text */.xv, {
                                                    children: "Vetter: ".concat(record.vetter.firstName, " ").concat((ref = record.vetter.lastName) === null || ref === void 0 ? void 0 : ref.charAt(0), ".")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                                justify: "center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Text */.xv, {
                                                    children: [
                                                        "Phone: ",
                                                        record.vetter.phone
                                                    ]
                                                })
                                            })
                                        ]
                                    }) : "No Vetter Information"
                                })
                            })
                        ]
                    });
                }
            },
            dataSource: data === null || data === void 0 ? void 0 : data.lastSessions.map((session)=>{
                // we need to add key to avoid expanding all the rows
                return {
                    ...session,
                    key: session === null || session === void 0 ? void 0 : session.id
                };
            }),
            scroll: {
                x: "100%"
            },
            columns: columns(sessionStatus),
            getRowLink: (record)=>{
                var ref, ref1;
                return (record === null || record === void 0 ? void 0 : record.id) ? getPath(pages.admin.clients_applicant_details({
                    clientId: (ref = record.jobOffer) === null || ref === void 0 ? void 0 : (ref1 = ref.client) === null || ref1 === void 0 ? void 0 : ref1.id,
                    sessionId: record.id
                })) : "#";
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardLayout/* DashboardLayout */.c, {
        loading: loading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageCard/* PageCard */.x, {
            title: "Dispatching",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(space/* default */.Z, {
                className: "dispatching",
                direction: "vertical",
                size: 12,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs/* default */.Z, {
                        centered: true,
                        defaultActiveKey: status,
                        onChange: (tab)=>callback(tab),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPane, {
                                tab: "In Progress",
                                children: table(generated/* SessionStatusFilterEnum.IN_PROGRESS */.Nn0.IN_PROGRESS)
                            }, generated/* SessionStatusFilterEnum.IN_PROGRESS */.Nn0.IN_PROGRESS),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPane, {
                                tab: "Completed",
                                children: table(generated/* SessionStatusFilterEnum.COMPLETED */.Nn0.COMPLETED)
                            }, generated/* SessionStatusFilterEnum.COMPLETED */.Nn0.COMPLETED)
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ../../libs/frontend-utils/src/firebase/auth/FirebaseClaims.tsx
var FirebaseClaims = __webpack_require__(93598);
;// CONCATENATED MODULE: ./pages/dispatching/index.tsx




const dispatching_Dispatching = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FirebaseClaims/* FirebaseClaims */.h, {
        children: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Dispatching, {})
    });
/* harmony default export */ var dispatching = (dispatching_Dispatching);


/***/ }),

/***/ 36284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ normalize; }
/* harmony export */ });
const normalize = (phone)=>{
    const plainNumbers = phone === null || phone === void 0 ? void 0 : phone.replace(/\D/g, "");
    return "+".concat(!(plainNumbers === null || plainNumbers === void 0 ? void 0 : plainNumbers.startsWith("1")) ? "1" : "").concat(plainNumbers);
};


/***/ }),

/***/ 48892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useLoadingPromiseHandler; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

const useLoadingPromiseHandler = function(callback) {
    let initiallyLoading = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initiallyLoading);
    const wrappedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        setLoading(true);
        try {
            await callback(args);
        } catch (e) {
            setLoading(false);
            throw e;
        }
        setLoading(false);
    }, [
        callback,
        setLoading
    ]);
    return [
        wrappedCallback,
        {
            loading
        }
    ];
};


/***/ }),

/***/ 72605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useThrottleSubscription; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76635);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


const useThrottleSubscription = (throttleFn, throttleWait, subscription, subscriptionOptions)=>{
    const refetch = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>(0,lodash__WEBPACK_IMPORTED_MODULE_0__.throttle)(throttleFn, throttleWait), [
        throttleFn,
        throttleWait
    ]);
    subscription({
        fetchPolicy: "no-cache",
        onSubscriptionData: ()=>{
            refetch();
        },
        ...subscriptionOptions
    });
};


/***/ }),

/***/ 65850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ PhoneInput; }
});

// UNUSED EXPORTS: phoneInputValidations

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/common-utils/src/phone.ts
var phone = __webpack_require__(36284);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
// EXTERNAL MODULE: ../../node_modules/react-phone-input-2/lib/lib.js
var lib = __webpack_require__(84695);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/PhoneInput/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-input {\n    padding: 13px 12px;\n    border-radius: 12px;\n    font-size: 15px;\n    line-height: 140%;\n  }\n\n  & .ant-input:focus,\n  & .ant-input:hover {\n    border-color: ",
        ";\n    box-shadow: none;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}


const Wrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.black30;
});
const Input = (0,styled_components_browser_esm/* default */.ZP)((lib_default()))(_templateObject1());

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/PhoneInput/index.tsx





const PhoneInput = (param)=>{
    let { onChange , ...props } = param;
    const handleOnChange = (0,react.useCallback)((value, data, event, formattedValue)=>{
        return onChange === null || onChange === void 0 ? void 0 : onChange(phone/* normalize */.F(value), data, event, formattedValue);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrap, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
            inputClass: "ant-input",
            specialLabel: "",
            disableDropdown: true,
            onChange: handleOnChange,
            ...props
        })
    });
};


/***/ }),

/***/ 78623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ Table; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/antd/es/config-provider/index.js + 6 modules
var config_provider = __webpack_require__(53486);
// EXTERNAL MODULE: ../../node_modules/antd/es/table/index.js + 107 modules
var table = __webpack_require__(52865);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/core/networkStatus.js
var core_networkStatus = __webpack_require__(64368);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/theme.ts
var theme = __webpack_require__(32657);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
// EXTERNAL MODULE: ../../node_modules/antd/es/empty/index.js + 2 modules
var empty = __webpack_require__(18020);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Typography/styles.tsx + 19 modules
var styles = __webpack_require__(71951);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Empty/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  padding: 22px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 64px;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}



const Wrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject());
const Empty = (0,styled_components_browser_esm/* default */.ZP)(empty/* default */.Z)(_templateObject1());
const Wrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2());
const Label = (0,styled_components_browser_esm/* default */.ZP)(styles/* Text */.xv)(_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.colors.grey40;
});
const Image = styled_components_browser_esm/* default.img */.ZP.img(_templateObject4());

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Empty/index.tsx



const Empty_Empty = (props)=>{
    return /*#__PURE__*/ _jsx(S.Wrap, {
        children: /*#__PURE__*/ _jsx(S.Empty, {
            ...props
        })
    });
};
const NoData = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                src: "/images/empty.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                children: "No data"
            })
        ]
    });
const NoResults = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                src: "/images/eyes.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                children: "Oops! We have not found any results for your search query."
            })
        ]
    });

// EXTERNAL MODULE: ../../node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(48562);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Table/styles.ts

function styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  gap: ",
        ";\n  flex-direction: column;\n\n  & .ant-table-tbody > tr > td,\n  & .ant-table-thead > tr > th {\n    border-color: ",
        ";\n  }\n\n  & .ant-table-wrapper {\n    width: 100%;\n\n    & .ant-table-thead > tr > th::before {\n      content: none !important;\n    }\n    & .ant-table-thead > tr > th {\n      font-weight: 600;\n    }\n\n    .ant-table-row:hover > td,\n    .ant-table-cell-row-hover {\n      background: ",
        ";\n    }\n\n    .ant-table-row-level-0 {\n      position: relative;\n    }\n\n    button {\n      z-index: 777;\n    }\n\n    .ant-select {\n      z-index: 777;\n    }\n\n    .ant-table-cell-fix-left {\n      z-index: 778;\n    }\n\n    .ant-table-placeholder .table-cell-content {\n      width: 100% !important;\n      font-size: 15px;\n      font-weight: 400;\n    }\n\n    & .table-cell-content {\n      width: 100% !important;\n      font-size: 15px;\n      font-weight: 400;\n    }\n\n    // Extra line above first visible table row\n    // Usefull when we do not show table header\n    .ant-table-row:nth-of-type(2) > td {\n      border-top: 1px solid ",
        ";\n    }\n\n    .ant-table-tbody > tr > td {\n      padding: ",
        ";\n    }\n\n    .ant-table-tbody > tr > td a.table-cell-link {\n      padding: 16px 16px;\n      display: table-cell;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n    }\n  }\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 53px;\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  height: 60vh;\n  .ant-skeleton-title {\n    height: ",
        "px;\n    border-radius: ",
        ";\n    display: flex;\n    flex: 1;\n    margin-top: 0;\n  }\n"
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}


const styles_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject(), (param)=>{
    let { $gap  } = param;
    return typeof $gap === "number" ? "".concat($gap, "px") : "24px";
}, (param)=>{
    let { theme  } = param;
    return theme.colors.grey20;
}, (param)=>{
    let { theme , $disableHoverAnimation  } = param;
    return $disableHoverAnimation ? "none" : theme.colors.yellow10;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.grey10;
}, (param)=>{
    let { $rowPadding  } = param;
    return typeof $rowPadding === "number" ? "".concat($rowPadding, "px ").concat($rowPadding, "px") : undefined;
});
const Placeholder = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject1());
const PlaceholderSkeleton = (0,styled_components_browser_esm/* default */.ZP)(skeleton/* default */.Z).attrs({
    title: true,
    paragraph: false,
    active: true
})(styles_templateObject2(), (param)=>{
    let { isHeader  } = param;
    return isHeader ? 54 : 1;
}, (param)=>{
    let { isHeader  } = param;
    return isHeader ? "12px 12px 0 0" : 0;
});

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Table/index.tsx







const Table_Placeholder = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Placeholder, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaceholderSkeleton, {
                isHeader: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaceholderSkeleton, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaceholderSkeleton, {})
        ]
    });
const LinkContext = /*#__PURE__*/ (0,react.createContext)(null);
const Table = /*#__PURE__*/ (0,react.forwardRef)(// eslint-disable-next-line @typescript-eslint/ban-types
function(param, ref) {
    let { disableHoverAnimation , pageCardRef , columns , dataSource , loading , networkStatus , hasActiveFilters , header , headerGap , rowPadding , pagination , getRowLink , onRowClick , forbidExpand , empty , ...props } = param;
    const tableRef = (0,react.useRef)(null);
    const rowsRef = (0,react.useRef)({});
    const [previousLoadedDataSource, setPreviousLoadedDataSource] = (0,react.useState)(dataSource);
    const isInitialLoading = networkStatus === core_networkStatus/* NetworkStatus.loading */.I.loading;
    const isSubsequentLoading = networkStatus && networkStatus < core_networkStatus/* NetworkStatus.poll */.I.poll && !isInitialLoading;
    (0,react.useEffect)(()=>{
        if (!isInitialLoading && !isSubsequentLoading) setPreviousLoadedDataSource(dataSource);
    }, [
        dataSource,
        isInitialLoading,
        isSubsequentLoading
    ]);
    (0,react.useImperativeHandle)(ref, ()=>({
            focusSelectedRow: (rowKey)=>{
                setTimeout(()=>{
                    const row = rowsRef.current[rowKey];
                    if (row) {
                        row.scrollIntoView({
                            block: "center",
                            inline: "nearest"
                        });
                        row.animate({
                            backgroundColor: [
                                theme/* theme.colors.yellow20 */.r.colors.yellow20,
                                theme/* theme.colors.white */.r.colors.white
                            ]
                        }, 10000);
                    }
                }, 0);
            }
        }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(config_provider/* default */.ZP, {
        renderEmpty: empty ? empty : hasActiveFilters ? NoResults : NoData,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Wrapper, {
            $disableHoverAnimation: disableHoverAnimation,
            $gap: headerGap,
            $rowPadding: rowPadding,
            children: [
                header,
                loading || isInitialLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Table_Placeholder, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* default */.Z, {
                    rowKey: "id",
                    ref: tableRef,
                    columns: columns,
                    dataSource: !(dataSource === null || dataSource === void 0 ? void 0 : dataSource.length) && isSubsequentLoading ? previousLoadedDataSource : dataSource,
                    loading: isSubsequentLoading,
                    pagination: pagination,
                    onChange: (_, __, ___, extra)=>{
                        if (extra.action === "paginate") {
                            if (pageCardRef) pageCardRef.scrollToTop();
                        }
                    },
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    onRow: (args)=>{
                        return {
                            onClick: (e)=>{
                                const selectDropdownClassNames = [
                                    "ant-select-item-option-content",
                                    "ant-select-selection-item"
                                ];
                                if (typeof e.target.className === "string" && !e.target.className.split(" ").some((className)=>selectDropdownClassNames.includes(className))) onRowClick === null || onRowClick === void 0 ? void 0 : onRowClick(args === null || args === void 0 ? void 0 : args.id);
                            }
                        };
                    },
                    components: {
                        body: {
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            row: (rowProps)=>{
                                var ref;
                                const record = (ref = rowProps.children[0]) === null || ref === void 0 ? void 0 : ref.props.record;
                                const id = record === null || record === void 0 ? void 0 : record.id;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkContext.Provider, {
                                    value: (()=>{
                                        if (typeof getRowLink === "function") return getRowLink(record) || null;
                                        return null;
                                    })(),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                        ...rowProps,
                                        ref: (el)=>id && (rowsRef.current[id] = el)
                                    })
                                });
                            },
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            cell: (cellProps)=>{
                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                const link = (0,react.useContext)(LinkContext);
                                const { children , ...restCellProps } = cellProps;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                    ...restCellProps,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell-content",
                                            children: children
                                        }),
                                        link && (dataSource === null || dataSource === void 0 ? void 0 : dataSource.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "table-cell-link",
                                            href: link,
                                            children: " "
                                        }) : null
                                    ]
                                });
                            }
                        }
                    },
                    ...forbidExpand ? {
                        // hack because of antd bug - not allowing to disable expand icon when "children" prop is present
                        expandable: {
                            childrenColumnName: "non_existing"
                        }
                    } : {},
                    ...props
                })
            ]
        })
    });
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3174,4544,7481,611,6868,4823,1006,9206,2688,2865,3319,1511,7911,2538,7987,1276,9774,2888,179], function() { return __webpack_exec__(61180); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);